import { connect } from 'react-redux'
import getSolarEvents from '../../services/solar-api'

import DayPageView from './DayPageView'

import {
  nowSelector,
  dateSelector,
  tideStationSelector,
} from '../../reducers/uiReducer'

import {
  dateTidesSelector,
  tideHeightRangeSelector,
} from '../../reducers/tidesReducer'




const mapStateToProps = (state) => {
  const date        = dateSelector(state)
  const tideStation = tideStationSelector(state)
  const tideEvents  = dateTidesSelector(state, 'DAY')

  // Get sunrise & sunset
  const lat = parseFloat(tideStation.lat)
  const lng = parseFloat(tideStation.lng)
  const solarEvents = getSolarEvents(date, lat, lng)

  // Combine tides and solar events into one array sorted by time
  const events = tideEvents.concat(solarEvents).sort((a, b) => a.moment - b.moment)

  return {
    now: nowSelector(state),
    date,
    events,
    threeDayTides: dateTidesSelector(state, 'THREE_DAY'),
    tideHeightRange: tideHeightRangeSelector(state, tideStation.stationId),
    tidesLoading: tideEvents.length === 0,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DayPageView)



// WEBPACK FOOTER //
// ./src/components/DayPage/DayPage.js